import React from 'react'
import { TreeAppButtons } from '@fs/zion-mobile-app-buttons'
import { Bleed, Grid, H2, Image, LayoutBand, Paragraph, Separator, usePageWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

import phoneAltImage from './phone-alt.webp'
import phoneImage from './phone.webp'

export default function MobileAppSection({ color, mobileBgImage, bgImage, backgroundPosition, backgroundSize }) {
  const { t } = useTranslation()
  const atWidth = usePageWidth()
  const isMobile = atWidth({ default: true, xl: false })

  return (
    <LayoutBand
      marginY="xl"
      color={color}
      image={isMobile ? mobileBgImage : bgImage}
      style={{
        backgroundPosition: backgroundPosition || (isMobile ? 'bottom center' : 'right center'),
        backgroundSize: backgroundSize || (isMobile ? '100% auto' : 'auto 100%'),
      }}
    >
      <Grid>
        <div columns={isMobile ? 12 : 5} alignY="middle">
          <H2 size={isMobile ? 'H2' : 'H3'} supplementary centered={isMobile} balanced>
            {t('apac.nlihp.mobile-app-section.heading', 'Discover the FamilySearch App')}
          </H2>
          <Separator size="xs" />
          <div style={{ maxWidth: '400px', margin: isMobile ? '0 auto' : undefined }}>
            <Paragraph size="sm" centered={isMobile}>
              {t(
                'apac.nlihp.mobile-app-section.subheading',
                "FamilySearch's app is ready to help you dive in and find your ancestors, preserve their memories, and prepare records to help others find their ancestors."
              )}
            </Paragraph>
          </div>
          <Separator size="md" />
          <TreeAppButtons centered={isMobile} />
        </div>

        <Bleed columns={isMobile ? 12 : 7} bottom sides>
          <div>
            <Image
              maxHeight={isMobile ? 430 : 620}
              noCrop
              positionY="bottom"
              src={isMobile ? phoneAltImage : phoneImage}
              alt=""
            />
          </div>
        </Bleed>
      </Grid>
    </LayoutBand>
  )
}
